<ng-container>
  <cf-button [color]="color" class="w-100" size="lg" (click)="signUp()">
    <cf-icon className="d-flex" icon="microsoft" class="ms-0 bg-white rounded-1"></cf-icon>
    <ng-content></ng-content>
  </cf-button>
</ng-container>
